<div class="row mt-2" *ngIf="upload">
    <div class="col-7"  *ngIf="upload.failCount > 0 ">
<mat-card class="mx-2">
    <mat-card-title class="mb-3">{{'Common.FailedUpload'| translate}}</mat-card-title>
    <mat-card-content>
        <mat-spinner *ngIf="loading"></mat-spinner>
        <mat-table *ngIf="dataSource && dataSource.data.length > 0" class="mat-elevation-z8 mx-2">
          <ng-container matColumnDef="documentName">
            <mat-header-cell  *matHeaderCellDef class="col-4"> {{'Common.DocumentName' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let upload" class="col-4"> {{upload.documentName}}</mat-cell>
          </ng-container>
  
          <ng-container matColumnDef="notes">
            <mat-header-cell *matHeaderCellDef class="col"> {{'Common.Notes' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let upload" class="col"> {{upload.notes}} </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        
    </mat-card-content>
</mat-card>
</div>
<div class="col">

<mat-card class="mx-2">
 <mat-card-title class="mb-3">{{'Upload.Status'|translate}}</mat-card-title>
 <mat-card-content>
    <mat-spinner *ngIf="loading"></mat-spinner>
    <div *ngIf="upload">
    <div class="row justify-content-between"><div class="col"><strong>{{'Upload.TotalProceded' |translate}}</strong></div><div class="col"><strong>{{upload.totalDocumentsProcessed}}</strong></div></div>
    <mat-divider class="py-3"></mat-divider>
    <div class="row justify-content-between"><div class="col">{{'Upload.Successcount' |translate}}</div><div class="col"> {{upload.successCount}}</div></div>
     <div *ngIf="upload.failCount > 0" class="row justify-content-between"><div class="col text-danger" >{{'Upload.FailedCount' |translate}}</div><div class="col text-danger"> {{upload.failCount}}</div></div>

    <div class="row justify-content-between"><div class="col">{{'Upload.StartDate' |translate}}</div><div class="col">{{upload.processStartedOn| date: 'MM/dd/y, h:mm:ss a'}}</div></div>
     <div class="row justify-content-between"><div class="col">{{'Upload.EndDate' |translate}}</div><div class="col">{{upload.processEndedOn| date: 'MM/dd/y, h:mm:ss a'}}</div></div>
     
     </div>
 </mat-card-content>

</mat-card>
</div>
</div>